/*
 * Customization for footer logo
 *

 */

// eslint-disable-next-line import/no-unresolved
import { useSelector } from 'react-redux';

import { default as MainLogo } from 'nci-theme/components/Logo';
import cisstLogo from 'nci-theme/components/Logo/cisst.png';
import poliziaLogo from 'nci-theme/components/Logo/polizia.png';

const ImageLogo = ({ image, width, height }) => (
  <figure>
    <img
      src={image}
      width={width}
      height={height}
      alt=""
      loading="lazy"
      decoding="async"
    />
  </figure>
);

const LogoFooter = () => {
  const subsite = useSelector((state) => state.subsite?.data);

  switch (subsite?.subsite_css_class?.token) {
    case 'cisst':
      return <ImageLogo image={cisstLogo} height="75px" width="152px" />;
    case 'polizia':
      return <ImageLogo image={poliziaLogo} height="75px" width="75px" />;

    case 'ddt':
    case 'psc':
    case 'ssa':
    case 'tributi':
      return null;
    default:
      return <MainLogo fillColor="#fff" />;
  }
};

export default LogoFooter;
